import {
	BookingStateEnum,
	CurrencyCodeEnum,
	DiscountStateEnum,
	DisplayType,
	PassengerBookingView,
	PassengerLegStatusEnum,
	PaymentFormEnum,
	PaymentStateEnum,
	PriceType,
	SpecialNeedsEnum,
	TripTypeEnum,
} from '../';

export const booking_2Adults_3Toddlers_LBODTFLEX: PassengerBookingView = {
	bookingCode: 'ABCD',
	paymentState: PaymentStateEnum.PAID,
	passengerList: [
		{
			isMainPassenger: false,
			specialNeeds: SpecialNeedsEnum.NONE,
			discountState: DiscountStateEnum.NO_DISCOUNT,
		},
		{
			isMainPassenger: false,
			specialNeeds: SpecialNeedsEnum.NONE,
			discountState: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
		},
		{
			firstName: 'Smb',
			lastName: 'Another',
			email: 'sewr@sdf.sdf',
			phone: '123',
			isMainPassenger: true,
			specialNeeds: SpecialNeedsEnum.NONE,
			discountState: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
		},
	],
	passengers: 3,
	bookingNumber: '2024ZOTTQTYT',
	specialNeeds: SpecialNeedsEnum.NONE,
	bookingStatus: BookingStateEnum.NEW,
	itinerary: {
		startDateTime: '2024-03-14T13:05:47.837Z',
		endDateTime: '2024-03-14T14:50:41.837Z',
		duration: 2697,
		walkTime: 0,
		walkDistance: 0,
		paymentOptions: [PaymentFormEnum.DIGITAL],
		airDistance: 32390,
		legs: [
			{
				legId: '39fd7fcd-56dd-49b2-85e4-180f30957986',
				legStatus: PassengerLegStatusEnum.BOOKED,
				startDateTime: '2024-03-14T13:05:47.837Z',
				startDateTimeWindowStart: '2024-03-14T13:05:47.837883146Z',
				startDateTimeWindowEnd: '2024-03-14T13:20:47.837883146Z',
				startDateTimeFix: false,
				endDateTime: '2024-03-14T14:50:41.837Z',
				endDateTimeWindowStart: '2024-03-14T13:05:47.837883146Z',
				endDateTimeWindowEnd: '2024-03-14T14:50:41.837883146Z',
				endDateTimeFix: false,
				cancellationFreeUntil: '2024-03-14T12:05:47.837Z',
				costOfCancellation: 760,
				duration: 2697,
				distance: 39996.7,
				mode: TripTypeEnum.LBODTFLEX,
				modeOrigin: 'CAR',
				route: '',
				agencyName: 'Vetter Verkehrsbetriebe',
				from: {
					name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
					lng: '12.044637',
					lat: '51.855333',
					arrival: '2024-03-14T13:05:47.837Z',
					departure: '2024-03-14T13:05:47.837Z',
					locationType: DisplayType.ADDRESS,
				},
				to: {
					name: 'Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
					lng: '12.328808',
					lat: '51.623215',
					arrival: '2024-03-14T14:50:41.837Z',
					departure: '2024-03-14T14:50:41.837Z',
					locationType: DisplayType.ADDRESS,
				},
				// legGeometry: null,
				// interlineWithPreviousLeg: null,
				payment: {
					paymentAmount: 5090,
					currencyCode: CurrencyCodeEnum.EUR,
					paymentForm: PaymentFormEnum.DIGITAL,
					paymentState: PaymentStateEnum.TO_PAY,
					paymentInformationAvailable: true,
					originalPriceInfo: {
						priceType: PriceType.MOPLA,
						totalCostCents: 5090,
					},
				},
				paymentOptions: [PaymentFormEnum.DIGITAL],
				intermediateStops: [],
				pricings: [
					{
						paymentHandlerCompanyName: 'MoPla Solutions GmbH',
						paymentHandlerCompanyType: 'MOPLA',
						paymentInformationAvailable: true,
						amount: 760,
						currency: CurrencyCodeEnum.EUR,
						discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
						pricePerPassenger: 760,
						deploymentPrice: 0,
					},
					{
						paymentHandlerCompanyName: 'MoPla Solutions GmbH',
						paymentHandlerCompanyType: 'MOPLA',
						paymentInformationAvailable: true,
						amount: 860,
						currency: CurrencyCodeEnum.EUR,
						discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
						pricePerPassenger: 860,
						deploymentPrice: 0,
					},
					{
						paymentHandlerCompanyName: 'MoPla Solutions GmbH',
						paymentHandlerCompanyType: 'MOPLA',
						paymentInformationAvailable: true,
						amount: 1950,
						currency: CurrencyCodeEnum.EUR,
						discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
						pricePerPassenger: 1950,
						deploymentPrice: 0,
					},
					{
						paymentHandlerCompanyName: 'MoPla Solutions GmbH',
						paymentHandlerCompanyType: 'MOPLA',
						paymentInformationAvailable: true,
						amount: 2380,
						currency: CurrencyCodeEnum.EUR,
						discount: DiscountStateEnum.NO_DISCOUNT,
						pricePerPassenger: 2380,
						deploymentPrice: 0,
					},
				],
				lbodtflexLabel: 'AnrufbusFlex',
				timeInfo: {
					start: {
						startTime: '2025-05-08T10:53:02.564803Z',
						startTimeWindow: {
							start: '2025-05-08T10:53:02.564803Z',
							end: '2025-05-08T11:08:02.564803Z',
						},
						overwrittenStartTimeWindow: undefined,
						currentlyPredictedStartTime: undefined,
					},
					end: {
						endTime: '2025-05-15T13:15:06.564Z',
						endTimeWindow: {
							start: '2025-05-08T10:53:02.564803Z',
							end: '2025-05-08T12:38:06.564803Z',
						},
						overwrittenEndTimeWindow: undefined,
						currentlyPredictedEndTime: undefined,
					},
					includedPlannedDelayInMinutes: 0,
					startAndEndTimeFixed: false,
				},
			},
		],
		luggageDefinition:
			'Das Sperrgepäck darf nicht mehr als einen Sitzplatz einnehmen. Die Mitnahme ist kostenlos QA TEST... QA TEST',
		toddlersDefinition: 'Kinder von 0 - 5 Jahren reisen kostenlos... QATEST',
	},
	id: '0a1291f5-cc6b-4dc8-bfa2-197acf72da7d',
	deleted: false,
	payment: {
		paymentAmount: 5090,
		currencyCode: CurrencyCodeEnum.EUR,
		paymentForm: PaymentFormEnum.DIGITAL,
		paymentState: PaymentStateEnum.TO_PAY,
		paymentInformationAvailable: true,
	},
	originalPriceInfoAggregate: {
		priceTypes: [PriceType.MOPLA],
		totalCostCents: 5090,
		currencyCode: CurrencyCodeEnum.EUR,
	},
	toddlerSeats: 3,
	bulkyLuggage: true,
	updatedTime: '2025-05-07T16:22:54.857751Z',
};
